import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapGetters('region', ['regions']),
    },

    methods: {
        ...mapActions('region', ['getRegionListIfNecessary']),

        refreshRegionList: _.debounce(function(query) {
            this.getRegionListIfNecessary({ query: query });
        }, 500),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/region.js